<template>
    <div>
        <div class="modal hide fade" id="modalReturn" tabindex="-1" role="dialog" aria-labelledby="modalReturn" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">
                            Retur
                        </h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                      <div class="row">
                        <div class="col-md-6">
                          <dl class="row dl-custom">
                            <dd class="col-md-4">Type</dd>
                            <dt class="col-md-8">{{ retur.type }}</dt>

                            <dd class="col-md-4">Date</dd>
                            <dt class="col-md-8">{{ retur.return_date | dateFormat('DD/MM/YYYY') }}</dt>

                            <dd class="col-md-4">
                              <span v-if="retur.type === 'sales'">Sale No.</span>
                              <span v-else>Purchasing No.</span>
                            </dd>
                            <dt class="col-md-8">
                              <span v-if="retur.type === 'sales'">{{ retur.sale_no }}</span>
                              <span v-else>{{ retur.purchasing_no }}</span>
                            </dt>
                            <dd class="col-md-4">Company</dd>
                            <dt class="col-md-8">{{ retur.company }}</dt>

                            <dd class="col-md-4">Notes</dd>
                            <dt class="col-md-8">{{ retur.notes }}</dt>
                          </dl>
                        </div>
                        <div class="col-md-6">
                          <dl class="row dl-custom" v-if="retur.type === 'sales'">
                            <dd class="col-md-4">Customer</dd>
                            <dt class="col-md-8">{{ retur.customer_no }}</dt>

                            <dd class="col-md-4">Name</dd>
                            <dt class="col-md-8">{{ retur.customer }}</dt>
                          </dl>
                          <dl class="row dl-custom" v-else>
                            <dd class="col-md-4">Vendor</dd>
                            <dt class="col-md-8">{{ retur.vendor_no }}</dt>

                            <dd class="col-md-4">Name</dd>
                            <dt class="col-md-8">{{ retur.vendor }}</dt>
                          </dl>
                        </div>
                      </div>
                      <hr>
                      <div class="row">
                        <div class="col-md-12">
                          <div class="table-responsive">
                            <table class="table table-sm table-item table-hover table-striped">
                              <thead>
                                <th>Product</th>
                                <th class="text-center">Qty</th>
                                <th>Uom</th>
                                <th class="text-right">Amount</th>
                                <th class="text-right">Discount</th>
                                <th class="text-right">Tax</th>
                                <th class="text-right">Total</th>
                              </thead>
                              <tbody>
                                <tr v-for="d in retur.details" :key="d.id">
                                  <td><b>[{{ d.product_no }}]</b> {{ d.product }}</td>
                                  <td class="text-center">{{ d.qty }}</td>
                                  <td>{{ d.uom_id }}</td>
                                  <td class="text-right">{{ d.amount | currency }}</td>
                                  <td class="text-right">{{ d.discount | currency }}</td>
                                  <td class="text-right">{{ d.tax | currency }}</td>
                                  <td class="text-right">{{ d.total | currency }}</td>
                                </tr>
                              </tbody>
                              <tfoot>
                                <tr>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td class="text-right"><b>{{ totalRetur | currency }}</b></td>
                                </tr>
                              </tfoot>
                            </table>
                          </div>
                        </div>
                      </div>
                      <pre>{{ retur }}</pre>
                    </div>
                    <div class="modal-footer">
                      <button type="button" class="btn btn-sm btn-soft-primary" @click="setJournal">Set Journal</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Axios from 'axios'
import { mapState } from 'vuex'
import { getHeader, returnUrl } from '../../config'
export default {
  name: 'ReturnModal',
  computed: {
    ...mapState({
      retur: state => state.returs.return
    }),
    totalRetur () {
      var sum = 0
      var array = this.retur.details
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total)
      }
      return sum
    }
  },
  methods: {
    async setJournal () {
      var body = {
        id: this.retur.id
      }
      console.log(body)
      if (this.retur.type === 'sales') {
        await Axios.post(returnUrl + '/journal-sales/', body, { headers: getHeader() })
          .then(response => {
            console.log(response.data.message)
            this.$swal('Retur', response.data.message, 'success')
          })
          .catch(error => {
            console.log(error)
            console.log(error.response)
            this.$swal('Retur', error.response.data.message, 'error')
            throw error
          })
      } else if (this.retur.type === 'purchasing') {
        await Axios.post(returnUrl + '/journal-purchasing/', body, { headers: getHeader() })
          .then(response => {
            console.log(response.data.message)
            this.$swal('Retur', response.data.message, 'success')
          })
          .catch(error => {
            console.log(error)
            console.log(error.response)
            this.$swal('Retur', error.response.data.message, 'error')
            throw error
          })
      }
    }
  }
}
</script>
